import Paragraph from 'components/Typography/Paragraph';
import WrapperBox from 'components/WrapperBox';
import coin from 'assets/icons/coins/coin.png';
import {
  ChallengeCardContainer,
  ChallengeCardContent,
  ChallengeCardCoin,
  ChallengeCardImageCoin,
  ChallengeCardContentTitles,
  ChallengeCardImage,
} from './ChallengeCardV2.styles';
import { ChallengeCardProps } from './ChallengeCardV2.types';
import Title from 'components/Typography/Title';
import { handleCoins } from 'helpers/MissionsHelper';
import { useTranslation } from 'react-i18next';

const ChallengeCardV2 = ({
  width = '100%',
  height = '7.375rem',
  borderRadius = '0.875rem',
  shadowColor = '#007AD1',
  title,
  imageSrc,
  coins,
  distance,
  ...rest
}: ChallengeCardProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <WrapperBox
      width={width}
      height={height}
      shadowColor={shadowColor}
      borderRadius={borderRadius}
      clickable
      {...rest}
    >
      <ChallengeCardContainer>
        <ChallengeCardImage src={imageSrc} alt={title} />
        <ChallengeCardContent>
          <ChallengeCardContentTitles>
            <Paragraph className="whitespace-nowrap">
              {distance + ' ' + t('farfromyou')}{' '}
            </Paragraph>
            <Title level={3} renderAs="h3">
              {title}
            </Title>
          </ChallengeCardContentTitles>
          <ChallengeCardCoin>
            <Paragraph>{handleCoins(+coins)}</Paragraph>
            <ChallengeCardImageCoin src={coin} alt={coins} />
          </ChallengeCardCoin>
        </ChallengeCardContent>
      </ChallengeCardContainer>
    </WrapperBox>
  );
};

export default ChallengeCardV2;
